export const GET_TEMPLATE = 'GET_TEMPLATE'
export const POST_BALANCE_SHEET = 'POST_BALANCE_SHEET'
export const SET_CODES_OBJECT = 'SET_CODES_OBJECT'
export const GET_FINANCIAL_STATEMENTS = 'GET_FINANCIAL_STATEMENTS'
export const GET_FS_INPUTS = 'GET_FS_INPUTS'
export const UPDATE_BALANCE_SHEET = 'UPDATE_BALANCE_SHEET'



// WEBPACK FOOTER //
// ./src/actions/transformation_input_two.js